/**
 * PQ Hero Slideshow Pro
 * 支持 3 种数据源：Theme Blocks、Page Metafield (group_works.collection.banners 等)、以及 API / JS 动态注入。
 * 外置单例脚本，支持离屏自动暂停、拖拽手势、倒计时与外部 setSlides() 动态渲染。
 */
;(function () {
  if (window.pqHeroSlideshowPro) return

  const instances = new Map()
  const desktopMediaQuery = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: true }
  const pad2 = (n) => String(n).padStart(2, '0')

  function text(value) {
    return value == null ? '' : String(value).trim()
  }

  function safeUrl(value) {
    const url = text(value)
    if (!url) return ''
    if (url.startsWith('/') || url.startsWith('#') || url.startsWith('https://') || url.startsWith('http://')) {
      return url
    }
    return ''
  }

  function parseEndDate(raw) {
    const s = text(raw)
    if (!s) return null
    const normalized = s.replace(' ', 'T')
    const value = /[zZ]|[+\-]\d{2}:\d{2}$/.test(normalized)
      ? new Date(normalized)
      : new Date(`${normalized}+08:00`)
    return Number.isNaN(value.getTime()) ? null : value
  }

  function normalizeSlideItem(raw) {
    if (!raw || typeof raw !== 'object') return null
    const desktopUrl = safeUrl(
      raw.desktopUrl || raw.desktop_url || raw.image || raw.src || raw.url || raw.mobileUrl || raw.mobile_url
    )
    const mobileUrl = safeUrl(raw.mobileUrl || raw.mobile_url || desktopUrl)
    if (!desktopUrl) return null
    return {
      desktopUrl,
      mobileUrl: mobileUrl || desktopUrl,
      alt: text(raw.alt || raw.title || raw.heading),
      link: safeUrl(raw.link || raw.href || raw.pageUrl || raw.slide_link),
      newWindow: Boolean(raw.newWindow || raw.slide_link_new_window),
      anchorId: text(raw.anchorId || raw.slide_anchor_id).replace(/^#/, ''),
      subheading: text(raw.subheading),
      heading: text(raw.heading),
      headingTag: text(raw.headingTag || 'h2').toLowerCase(),
      textHtml: text(raw.text),
      overlayColor: text(raw.overlayColor) || '#202020',
      overlayOpacity: Number.isFinite(Number(raw.overlayOpacity)) ? Number(raw.overlayOpacity) : 0,
      desktopPosition: text(raw.desktopPosition) || 'middle-left',
      mobilePosition: text(raw.mobilePosition) || 'middle-center',
      desktopAlign: text(raw.desktopAlign) || 'left',
      mobileAlign: text(raw.mobileAlign) || 'center',
      buttonStyle: text(raw.buttonStyle) || 'square',
      firstButton: raw.firstButton && typeof raw.firstButton === 'object' ? raw.firstButton : null,
      secondButton: raw.secondButton && typeof raw.secondButton === 'object' ? raw.secondButton : null,
      countdown: raw.countdown && typeof raw.countdown === 'object' ? raw.countdown : null,
    }
  }

  function buildSlideElement(item, index) {
    const article = document.createElement('article')
    article.className = `pq-hero-slideshow__slide${index === 0 ? ' is-active' : ''}`
    article.setAttribute('data-pq-hero-slide', '')
    article.setAttribute('data-slide-index', String(index))
    article.style.setProperty('--pq-overlay-color', item.overlayColor)
    article.style.setProperty('--pq-overlay-opacity', String(item.overlayOpacity))

    const media = document.createElement('div')
    media.className = 'pq-hero-slideshow__media'
    media.setAttribute('aria-hidden', 'true')

    const picture = document.createElement('picture')
    picture.className = 'pq-hero-slideshow__picture'
    if (item.mobileUrl && item.mobileUrl !== item.desktopUrl) {
      const source = document.createElement('source')
      source.media = '(max-width: 749px)'
      source.srcset = item.mobileUrl
      picture.appendChild(source)
    }
    const img = document.createElement('img')
    img.className = 'pq-hero-slideshow__image pq-hero-slideshow__image--desktop pq-hero-slideshow__image--mobile-fallback'
    img.src = item.desktopUrl
    img.alt = item.alt
    img.loading = index === 0 ? 'eager' : 'lazy'
    img.decoding = 'async'
    if (index === 0) img.setAttribute('fetchpriority', 'high')
    picture.appendChild(img)
    media.appendChild(picture)
    article.appendChild(media)

    const overlay = document.createElement('div')
    overlay.className = 'pq-hero-slideshow__overlay'
    article.appendChild(overlay)

    if (item.anchorId || item.link) {
      const link = document.createElement('a')
      link.className = 'pq-hero-slideshow__slide-link'
      if (item.anchorId) {
        link.href = `#${item.anchorId}`
        link.setAttribute('data-pq-hero-anchor-link', '')
        link.setAttribute('data-anchor-id', item.anchorId)
      } else {
        link.href = item.link
        if (item.newWindow) {
          link.target = '_blank'
          link.rel = 'noopener noreferrer'
        }
      }
      link.setAttribute('aria-label', item.alt || item.heading || 'Banner link')
      article.appendChild(link)
    }

    if (item.subheading || item.heading || item.textHtml || item.firstButton || item.secondButton) {
      const content = document.createElement('div')
      content.className = `pq-hero-slideshow__content pq-hero-slideshow__content--desktop-${item.desktopPosition} pq-hero-slideshow__content--mobile-${item.mobilePosition}`
      const box = document.createElement('div')
      box.className = `pq-hero-slideshow__content-box pq-hero-slideshow__content-box--desktop-${item.desktopAlign} pq-hero-slideshow__content-box--mobile-${item.mobileAlign}`

      if (item.subheading) {
        const sub = document.createElement('p')
        sub.className = 'pq-hero-slideshow__subheading'
        sub.textContent = item.subheading
        box.appendChild(sub)
      }
      if (item.heading) {
        const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
        const tag = allowedTags.includes(item.headingTag) ? item.headingTag : 'h2'
        const h = document.createElement(tag)
        h.className = 'pq-hero-slideshow__heading'
        h.textContent = item.heading
        box.appendChild(h)
      }
      if (item.textHtml) {
        const desc = document.createElement('div')
        desc.className = 'pq-hero-slideshow__text rte'
        desc.textContent = item.textHtml
        box.appendChild(desc)
      }
      if (item.firstButton || item.secondButton) {
        const btns = document.createElement('div')
        btns.className = `pq-hero-slideshow__buttons pq-hero-slideshow__buttons--${item.buttonStyle}`
        ;[item.firstButton, item.secondButton].forEach((btnCfg, btnIdx) => {
          if (!btnCfg || !text(btnCfg.label)) return
          const a = document.createElement('a')
          const isPrimary = btnCfg.primary != null ? Boolean(btnCfg.primary) : btnIdx === 0
          a.className = `pq-hero-slideshow__button ${
            isPrimary ? 'pq-hero-slideshow__button--primary' : 'pq-hero-slideshow__button--secondary'
          }`
          const href = safeUrl(btnCfg.link)
          if (href) a.href = href
          else {
            a.setAttribute('role', 'link')
            a.setAttribute('aria-disabled', 'true')
          }
          if (btnCfg.newWindow) {
            a.target = '_blank'
            a.rel = 'noopener noreferrer'
          }
          a.textContent = text(btnCfg.label)
          btns.appendChild(a)
        })
        box.appendChild(btns)
      }
      content.appendChild(box)
      article.appendChild(content)
    }

    return article
  }

  function resolveRoot(rootOrId) {
    if (!rootOrId) return null
    if (typeof rootOrId === 'string') {
      return (
        document.getElementById(rootOrId) ||
        document.getElementById(`pq-hero-slideshow-pro-${rootOrId}`) ||
        document.querySelector(`[data-pq-hero-pro-section-id="${rootOrId}"]`)
      )
    }
    return rootOrId
  }

  function mount(root) {
    if (!root || root.dataset.pqHeroProInitialized === 'true') return instances.get(root.id)
    root.dataset.pqHeroProInitialized = 'true'

    const viewport = root.querySelector('.pq-hero-slideshow__viewport')
    const track = root.querySelector('[data-pq-hero-track]')
    const pagination = root.querySelector('[data-pq-hero-pagination]')
    const prev = root.querySelector('[data-pq-hero-prev]')
    const next = root.querySelector('[data-pq-hero-next]')
    const transition = root.dataset.transition || 'slide'
    const autoplay = root.dataset.autoplay === 'true'
    const showArrows = root.dataset.showArrows !== 'false'
    const paginationStyle = root.dataset.paginationStyle || 'bars'
    const interval = Math.max(parseInt(root.dataset.interval, 10) || 5000, 1000)
    const mobileScrollOffset = parseInt(root.dataset.scrollOffsetMobile, 10) || 0
    const desktopScrollOffset = parseInt(root.dataset.scrollOffsetDesktop, 10) || 0
    const designMode = root.dataset.designMode === 'true'
    const apiUrl = text(root.dataset.apiUrl)
    const apiPath = text(root.dataset.apiDataPath)

    let slides = Array.from(root.querySelectorAll('[data-pq-hero-slide]'))
    let pages = Array.from(root.querySelectorAll('[data-pq-hero-page]'))
    let current = 0
    let autoplayFrameId = null
    let countdownTimerId = null
    let slideStartedAt = 0
    let suppressSlideClick = false
    let fadeCleanupToken = 0
    let inViewport = true
    let io = null
    let fetchAbort = null
    let countdownData = []

    function visibleSlides() {
      return slides.filter((slide) => !slide.hidden)
    }

    function syncControlsVisibility() {
      const multi = visibleSlides().length > 1
      if (prev) prev.hidden = !multi || !showArrows
      if (next) next.hidden = !multi || !showArrows
      if (pagination) pagination.hidden = !multi || paginationStyle === 'none'
    }

    function scrollToAnchor(anchorId) {
      if (!anchorId) return false
      const target = document.getElementById(anchorId)
      if (!target) return false
      const targetElement = target.closest('[id^="shopify-section-"]') || target
      const offset = desktopMediaQuery.matches ? desktopScrollOffset : mobileScrollOffset
      const targetTop = targetElement.getBoundingClientRect().top + window.pageYOffset
      window.scrollTo({
        top: Math.max(targetTop - offset, 0),
        behavior: 'smooth',
      })
      return true
    }

    function normalizeIndex(index, direction = 1) {
      if (!slides.length) return 0
      let nextIndex = ((index % slides.length) + slides.length) % slides.length
      for (let i = 0; i < slides.length; i += 1) {
        const candidate = slides[nextIndex]
        if (candidate && !candidate.hidden) return nextIndex
        nextIndex = (nextIndex + direction + slides.length) % slides.length
      }
      return 0
    }

    function updatePagination() {
      pages.forEach((page) => {
        const pageIndex = parseInt(page.dataset.pqHeroPage, 10)
        const relatedSlide = slides[pageIndex]
        page.hidden = !relatedSlide || relatedSlide.hidden
        page.classList.toggle('is-active', pageIndex === current)
        if (pageIndex === current) page.setAttribute('aria-current', 'true')
        else page.removeAttribute('aria-current')
      })
      syncControlsVisibility()
    }

    function updatePaginationProgress(progress) {
      pages.forEach((page) => {
        const pageIndex = parseInt(page.dataset.pqHeroPage, 10)
        page.style.setProperty('--pq-slide-progress', pageIndex === current ? String(progress) : '0')
      })
    }

    function restingProgress() {
      return autoplay && visibleSlides().length > 1 ? 0 : 1
    }

    function slideImages(slide) {
      return slide ? Array.from(slide.querySelectorAll('img')) : []
    }

    function displayedImages(slide) {
      return slideImages(slide).filter((img) => {
        const style = window.getComputedStyle(img)
        return style.display !== 'none' && style.visibility !== 'hidden'
      })
    }

    function syncActiveAspectRatio(slide) {
      const img = displayedImages(slide)[0] || slideImages(slide)[0]
      if (!img) return

      const update = function () {
        if (!img.naturalWidth || !img.naturalHeight) return
        const ratio = (img.naturalWidth / img.naturalHeight).toFixed(6)
        const property = desktopMediaQuery.matches
          ? '--pq-active-desktop-aspect-ratio'
          : '--pq-active-mobile-aspect-ratio'
        root.style.setProperty(property, ratio)
      }

      update()
      if (!img.complete) {
        img.addEventListener('load', update, { once: true })
      }
    }

    function preloadSlideImages(index, direction = 1) {
      if (!slides.length) return
      const slide = slides[normalizeIndex(index, direction)]
      slideImages(slide).forEach((img) => {
        if (img.loading === 'lazy') img.loading = 'eager'
        if (!img.complete) {
          const preload = new Image()
          if (img.srcset) preload.srcset = img.srcset
          if (img.sizes) preload.sizes = img.sizes
          preload.src = img.currentSrc || img.src
        }
      })
    }

    function preloadAdjacentSlides() {
      if (visibleSlides().length < 2) return
      preloadSlideImages(current + 1, 1)
      preloadSlideImages(current - 1, -1)
    }

    function waitForImage(img) {
      if (img.complete && img.naturalWidth > 0) return Promise.resolve()
      return new Promise((resolve) => {
        const done = function () {
          img.removeEventListener('load', done)
          img.removeEventListener('error', done)
          resolve()
        }
        img.addEventListener('load', done, { once: true })
        img.addEventListener('error', done, { once: true })
      })
    }

    function waitForSlideImages(slide) {
      const images = displayedImages(slide)
      if (!images.length) return Promise.resolve()
      return Promise.race([
        Promise.all(images.map(waitForImage)),
        new Promise((resolve) => window.setTimeout(resolve, 3500)),
      ])
    }

    function wait(ms) {
      return new Promise((resolve) => window.setTimeout(resolve, ms))
    }

    function keepPreviousSlideUntilReady(previousSlide, nextSlide) {
      if (transition !== 'fade' || !previousSlide || previousSlide === nextSlide) return
      const token = ++fadeCleanupToken
      previousSlide.classList.add('is-fading-out')
      Promise.all([waitForSlideImages(nextSlide), wait(650)]).then(() => {
        if (token !== fadeCleanupToken) return
        previousSlide.classList.remove('is-fading-out')
      })
    }

    function goTo(index, direction = 1) {
      if (!slides.length) return
      const previousSlide = slides[current]
      current = normalizeIndex(index, direction)
      const nextSlide = slides[current]
      syncActiveAspectRatio(nextSlide)

      if (transition === 'fade') {
        preloadSlideImages(current, direction)
      }

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current
        if (transition === 'fade' && !active && slide !== previousSlide) {
          slide.classList.remove('is-fading-out')
        }
        slide.classList.toggle('is-active', active)
        slide.setAttribute('aria-hidden', active ? 'false' : 'true')
      })

      keepPreviousSlideUntilReady(previousSlide, nextSlide)

      if (transition === 'slide' && track) {
        const visiblePosition = visibleSlides().findIndex(
          (slide) => parseInt(slide.dataset.slideIndex, 10) === current
        )
        track.style.transform = `translateX(-${Math.max(visiblePosition, 0) * 100}%)`
      }

      updatePagination()
      updatePaginationProgress(restingProgress())
      preloadAdjacentSlides()
    }

    function goNext() {
      goTo(current + 1, 1)
    }

    function goPrev() {
      goTo(current - 1, -1)
    }

    function stopAutoplay() {
      if (autoplayFrameId) window.cancelAnimationFrame(autoplayFrameId)
      autoplayFrameId = null
    }

    function autoplayTick(now) {
      if (!inViewport || document.hidden) {
        stopAutoplay()
        return
      }
      if (!slideStartedAt) slideStartedAt = now
      const progress = Math.min((now - slideStartedAt) / interval, 1)
      updatePaginationProgress(progress)

      if (progress >= 1) {
        goNext()
        slideStartedAt = now
        updatePaginationProgress(0)
      }

      autoplayFrameId = window.requestAnimationFrame(autoplayTick)
    }

    function startAutoplay() {
      stopAutoplay()
      if (!autoplay || visibleSlides().length < 2 || !inViewport || document.hidden) {
        updatePaginationProgress(visibleSlides().length < 2 ? 1 : 0)
        return
      }
      updatePaginationProgress(0)
      slideStartedAt = 0
      autoplayFrameId = window.requestAnimationFrame(autoplayTick)
    }

    function bindPaginationButtons() {
      pages = pagination ? Array.from(pagination.querySelectorAll('[data-pq-hero-page]')) : []
      pages.forEach((page) => {
        if (page.dataset.pqBound === 'true') return
        page.dataset.pqBound = 'true'
        page.addEventListener('click', function () {
          goTo(parseInt(page.dataset.pqHeroPage, 10) || 0, 1)
          startAutoplay()
        })
      })
    }

    function rebuildPagination(count) {
      if (!pagination) return
      pagination.replaceChildren()
      for (let i = 0; i < count; i += 1) {
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = `pq-hero-slideshow__pagination-button${i === 0 ? ' is-active' : ''}`
        btn.setAttribute('data-pq-hero-page', String(i))
        btn.setAttribute('aria-label', `Go to slide ${i + 1}`)
        const span = document.createElement('span')
        span.appendChild(document.createElement('i'))
        btn.appendChild(span)
        pagination.appendChild(btn)
      }
      bindPaginationButtons()
    }

    function bindAnchorLinks() {
      root.querySelectorAll('[data-pq-hero-anchor-link]').forEach((link) => {
        if (link.dataset.pqBound === 'true') return
        link.dataset.pqBound = 'true'
        link.addEventListener('click', function (event) {
          if (suppressSlideClick) return
          const anchorId = link.dataset.anchorId || ''
          event.preventDefault()
          if (!scrollToAnchor(anchorId) && designMode && window.console) {
            console.warn(`[PQ Hero Slideshow Pro] Anchor target not found: #${anchorId}`)
          }
        })
      })
    }

    function setValue(el, value) {
      if (el && el.textContent !== value) el.textContent = value
    }

    function expireCountdown(item) {
      setValue(item.refs.dd, '00')
      setValue(item.refs.hh, '00')
      setValue(item.refs.mm, '00')
      setValue(item.refs.ss, '00')
      item.expired = true

      if (item.behavior === 'hide_countdown') {
        item.box.classList.add('is-hidden')
      }

      if (item.behavior === 'hide_slide') {
        const slide = item.box.closest('[data-pq-hero-slide]')
        if (slide) {
          const wasActive = slide.classList.contains('is-active')
          slide.hidden = true
          if (wasActive) goNext()
          updatePagination()
          startAutoplay()
        }
      }
    }

    function tickCountdowns() {
      const now = new Date()
      countdownData.forEach((item) => {
        if (item.expired) return
        const diff = item.end - now
        if (diff <= 0) {
          expireCountdown(item)
          return
        }
        const sec = Math.floor(diff / 1000)
        const d = Math.floor(sec / 86400)
        const h = Math.floor((sec % 86400) / 3600)
        const m = Math.floor((sec % 3600) / 60)
        const s = sec % 60

        setValue(item.refs.dd, d > 99 ? '99' : pad2(d))
        setValue(item.refs.hh, pad2(h))
        setValue(item.refs.mm, pad2(m))
        setValue(item.refs.ss, pad2(s))
      })
    }

    function setupCountdowns() {
      if (countdownTimerId) {
        window.clearInterval(countdownTimerId)
        countdownTimerId = null
      }
      const countdowns = Array.from(root.querySelectorAll('[data-pq-countdown]'))
      countdownData = countdowns
        .map((box) => ({
          box,
          end: parseEndDate(box.dataset.end),
          behavior: box.dataset.expiredBehavior || 'show_zero',
          refs: {
            dd: box.querySelector('[data-key="dd"]'),
            hh: box.querySelector('[data-key="hh"]'),
            mm: box.querySelector('[data-key="mm"]'),
            ss: box.querySelector('[data-key="ss"]'),
          },
          expired: false,
        }))
        .filter((item) => item.end)

      if (countdownData.length) {
        tickCountdowns()
        countdownTimerId = window.setInterval(tickCountdowns, 1000)
      }
    }

    function setSlides(rawList) {
      if (!track) return
      const normalized = (Array.isArray(rawList) ? rawList : []).map(normalizeSlideItem).filter(Boolean)
      stopAutoplay()
      track.replaceChildren()

      if (!normalized.length) {
        slides = []
        rebuildPagination(0)
        syncControlsVisibility()
        if (!designMode) root.hidden = true
        return
      }

      root.hidden = false
      const frag = document.createDocumentFragment()
      normalized.forEach((item, index) => {
        frag.appendChild(buildSlideElement(item, index))
      })
      track.appendChild(frag)
      slides = Array.from(track.querySelectorAll('[data-pq-hero-slide]'))
      current = 0
      rebuildPagination(slides.length)
      bindAnchorLinks()
      setupCountdowns()
      goTo(0, 1)
      startAutoplay()
    }

    async function loadFromApi(url, path) {
      const targetUrl = safeUrl(url)
      if (!targetUrl) return
      if (fetchAbort) fetchAbort.abort()
      fetchAbort = typeof AbortController !== 'undefined' ? new AbortController() : null
      try {
        const res = await fetch(targetUrl, {
          method: 'GET',
          credentials: 'omit',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
          signal: fetchAbort && fetchAbort.signal,
        })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const body = await res.json()
        let list = body
        if (path) {
          path
            .split('.')
            .map((k) => k.trim())
            .filter(Boolean)
            .forEach((k) => {
              list = list && typeof list === 'object' ? list[k] : null
            })
        } else if (body && typeof body === 'object' && !Array.isArray(body)) {
          const inner = body.data || body.collection || body
          list = inner.banners || inner.slides || inner.items || []
        }
        setSlides(Array.isArray(list) ? list : [])
      } catch (error) {
        if (error && error.name === 'AbortError') return
        if (!slides.length && !designMode) root.hidden = true
      }
    }

    function onPrevClick() {
      goPrev()
      startAutoplay()
    }

    function onNextClick() {
      goNext()
      startAutoplay()
    }

    function onBlockSelect(event) {
      if (!root.contains(event.target)) return
      if (!event.detail || !event.detail.blockId) return
      const selectedSlide = slides.find((slide) => slide.dataset.blockId === event.detail.blockId)
      if (!selectedSlide) return
      const selectedIndex = parseInt(selectedSlide.dataset.slideIndex, 10)
      stopAutoplay()
      goTo(Number.isNaN(selectedIndex) ? 0 : selectedIndex, selectedIndex >= current ? 1 : -1)
    }

    function onCaptureClick(event) {
      if (!suppressSlideClick) return
      const target = event.target
      if (target && target.closest && target.closest('.pq-hero-slideshow__slide-link')) {
        event.preventDefault()
        event.stopPropagation()
      }
    }

    function onMediaChange() {
      if (slides[current]) syncActiveAspectRatio(slides[current])
    }

    function onVisibilityChange() {
      if (document.hidden) stopAutoplay()
      else startAutoplay()
    }

    if (prev) prev.addEventListener('click', onPrevClick)
    if (next) next.addEventListener('click', onNextClick)
    bindPaginationButtons()
    bindAnchorLinks()
    document.addEventListener('shopify:block:select', onBlockSelect)
    document.addEventListener('visibilitychange', onVisibilityChange)
    root.addEventListener('focusin', stopAutoplay)
    root.addEventListener('focusout', startAutoplay)
    root.addEventListener('click', onCaptureClick, true)

    let cleanupPointer = null
    if (viewport) {
      let pointerActive = false
      let pointerMoved = false
      let pointerStartX = 0
      let pointerStartY = 0
      let pointerLastX = 0
      let pointerLastY = 0
      let pointerCaptured = false

      const endDrag = function (event) {
        if (!pointerActive) return
        pointerActive = false
        viewport.classList.remove('is-dragging')

        if (pointerCaptured && viewport.releasePointerCapture && event.pointerId != null) {
          try {
            viewport.releasePointerCapture(event.pointerId)
          } catch (error) {
            /* Ignore release failures */
          }
        }
        pointerCaptured = false

        const dx = pointerLastX - pointerStartX
        const dy = pointerLastY - pointerStartY
        const shouldSwitch = pointerMoved && Math.abs(dx) >= 42 && Math.abs(dx) > Math.abs(dy)

        if (pointerMoved) {
          suppressSlideClick = true
          window.setTimeout(function () {
            suppressSlideClick = false
          }, 250)
        }

        if (shouldSwitch) {
          if (dx < 0) goNext()
          else goPrev()
        }

        startAutoplay()
      }

      const onPointerDown = function (event) {
        if (visibleSlides().length < 2) return
        const target = event.target
        if (
          target &&
          target.closest &&
          target.closest(
            '.pq-hero-slideshow__arrow, .pq-hero-slideshow__pagination-button, .pq-hero-slideshow__button'
          )
        ) {
          return
        }
        pointerActive = true
        pointerMoved = false
        pointerStartX = event.clientX
        pointerStartY = event.clientY
        pointerLastX = event.clientX
        pointerLastY = event.clientY
        pointerCaptured = false
        viewport.classList.add('is-dragging')
        stopAutoplay()
      }

      const onPointerMove = function (event) {
        if (!pointerActive) return
        pointerLastX = event.clientX
        pointerLastY = event.clientY
        const dx = pointerLastX - pointerStartX
        const dy = pointerLastY - pointerStartY
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          if (!pointerCaptured && viewport.setPointerCapture && event.pointerId != null) {
            try {
              viewport.setPointerCapture(event.pointerId)
              pointerCaptured = true
            } catch (error) {
              pointerCaptured = false
            }
          }
          pointerMoved = true
          event.preventDefault()
        }
      }

      viewport.addEventListener('pointerdown', onPointerDown)
      viewport.addEventListener('pointermove', onPointerMove)
      viewport.addEventListener('pointerup', endDrag)
      viewport.addEventListener('pointercancel', endDrag)
      cleanupPointer = function () {
        viewport.removeEventListener('pointerdown', onPointerDown)
        viewport.removeEventListener('pointermove', onPointerMove)
        viewport.removeEventListener('pointerup', endDrag)
        viewport.removeEventListener('pointercancel', endDrag)
      }
    }

    if (desktopMediaQuery.addEventListener) {
      desktopMediaQuery.addEventListener('change', onMediaChange)
    } else if (desktopMediaQuery.addListener) {
      desktopMediaQuery.addListener(onMediaChange)
    }

    if (typeof IntersectionObserver !== 'undefined') {
      io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            inViewport = entry.isIntersecting
            if (inViewport) startAutoplay()
            else stopAutoplay()
          })
        },
        { threshold: 0.05 }
      )
      io.observe(root)
    }

    if (slides.length) {
      setupCountdowns()
      goTo(0)
      startAutoplay()
    } else {
      syncControlsVisibility()
    }

    if (apiUrl) {
      void loadFromApi(apiUrl, apiPath)
    }

    function destroy() {
      stopAutoplay()
      if (fetchAbort) fetchAbort.abort()
      if (countdownTimerId) window.clearInterval(countdownTimerId)
      if (io) io.disconnect()
      if (prev) prev.removeEventListener('click', onPrevClick)
      if (next) next.removeEventListener('click', onNextClick)
      if (cleanupPointer) cleanupPointer()
      document.removeEventListener('shopify:block:select', onBlockSelect)
      document.removeEventListener('visibilitychange', onVisibilityChange)
      root.removeEventListener('focusin', stopAutoplay)
      root.removeEventListener('focusout', startAutoplay)
      root.removeEventListener('click', onCaptureClick, true)
      if (desktopMediaQuery.removeEventListener) {
        desktopMediaQuery.removeEventListener('change', onMediaChange)
      } else if (desktopMediaQuery.removeListener) {
        desktopMediaQuery.removeListener(onMediaChange)
      }
      instances.delete(root.id)
      delete root.dataset.pqHeroProInitialized
    }

    const api = {
      root,
      goTo,
      next: goNext,
      prev: goPrev,
      setSlides,
      loadFromApi,
      startAutoplay,
      stopAutoplay,
      destroy,
    }

    instances.set(root.id, api)
    root._pqHeroPro = api
    return api
  }

  function autoBoot() {
    document.querySelectorAll('[data-pq-hero-slideshow-pro]').forEach(mount)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoBoot, { once: true })
  } else {
    autoBoot()
  }

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event.detail && event.detail.sectionId
    const api = sectionId && instances.get(`pq-hero-slideshow-pro-${sectionId}`)
    if (api) api.destroy()
  })

  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail && event.detail.sectionId
    const root = sectionId && document.getElementById(`pq-hero-slideshow-pro-${sectionId}`)
    if (root) mount(root)
  })

  window.pqHeroSlideshowPro = {
    mount,
    get(rootOrId) {
      const root = resolveRoot(rootOrId)
      return (root && instances.get(root.id)) || null
    },
    setSlides(rootOrId, slidesArray) {
      const root = resolveRoot(rootOrId)
      const api = root ? mount(root) : null
      if (api) api.setSlides(slidesArray)
    },
    goTo(rootOrId, index) {
      const api = this.get(rootOrId)
      if (api) api.goTo(index, 1)
    },
    next(rootOrId) {
      const api = this.get(rootOrId)
      if (api) api.next()
    },
    prev(rootOrId) {
      const api = this.get(rootOrId)
      if (api) api.prev()
    },
  }
})()
